<template>
    <div class="poster-share-c" v-show="isShow">
        <div class="poster-c">
            <img :src="posterImg" class="poster" v-if="posterImg" id="posterImg" :style="{height:posterMaxHeight+'px'}"/>
            <div class="poster-toast" v-if="showToast" >{{toastTxt}}</div>
        </div>
        <!-- 分享浮层 -->
        <share @closeShareMask="handleCancle" @handleShowToast="handleShowToast"/>
        <!-- 海报dom -->
        <poster-dom class="poster-dom" id="posterDom"/>
    </div>
</template>

<script>
import Share from './share.vue'
import PosterDom from './poster-dom.vue'
import convertToImage from '../../../src/js/article-main/convert2canvas'

export default {
    components: {
        Share,
        PosterDom
    },
    data () {
        return {
            isShow: false,
            posterImg: '',
            showSaveToast: false,
            toastTxt: '海报生成中,请稍后....',
            posterMaxHeight: (window?.screen?.availHeight - 320)
        }
    },
    methods: {
        // 动态加载html2canvas
        loadHtmlToCanvas() {
            new window.MptcfeUtils.Jsonp({
                url: 'https://p.cdn.sohu.com/app/h5lib/html2canvas.100rc4.js',
                data: '',
                time: 2000,// 2秒
            })
        },
        handleShowToast() {
            this.showSaveToast = true
        },
        handleshowPosterShare() {
            this.isShow = true
        },
        handleCancle() {
            this.isShow = false
        },
        generatePoster() {
            let posterDom = document.querySelector('#posterDom')
            if(convertToImage) {
                convertToImage(posterDom, {
                    scale: 3,
                    y: window.pageYOffset,
                }).then((canvas) => {
                    this.posterImg = canvas.toDataURL()
                    window.eventBus.$emit('updatePosterImg',this.posterImg)
                })
            }else {
                this.toastTxt = '生成失败，稍后重试'
            }
        }
    },
    watch: {
        isShow(_new) {
            if(_new && !this.posterImg) {
                setTimeout(() => {
                    this.generatePoster()
                })
            }
        },
        showSaveToast(_new) {
            if(_new) {
                this.toastTxt = '长按图片保存'
                setTimeout(()=>{
                    this.showSaveToast = false
                },1000)
            }
        }
    },
    computed: {
        showToast() {
            return !this.posterImg || this.showSaveToast
        }
    },
    mounted() {
        window.eventBus.$on('showPoster',this.handleshowPosterShare)
    },
    created() {
        this.loadHtmlToCanvas()
    }
    
}
</script>
<style lang="less" scoped>
    .poster-share-c {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1000;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .poster-c {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            .poster {
                width: calc(100vw - 40px);
                object-fit: contain;
            }
            .poster-toast {
                position: absolute;
                z-index: 1001;
                height: 84px;/*px*/
                background: rgba(0,0,0,0.7);
                border-radius: 8px;/*px*/
                padding-left: 24px;/*px*/
                padding-right: 24px;/*px*/
                font-size: 32px;/*px*/
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 84px;/*px*/
                box-sizing: border-box;
            }
        }
        .poster-dom {
            position: absolute;
            left: -1400px;/*px*/
            top: 0;
        }
    }

</style>